"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
const errors_1 = require("./errors");
const FileUploadUnprocessableEntityError_1 = require("./errors/FileUploadUnprocessableEntityError");
class ChatbotServiceClient extends client_library_1.Client {
    constructor(fetch, options) {
        super(fetch, options);
        this.functionURL = options.functionURL;
    }
    async query(params, accessToken, region) {
        const options = {
            method: 'POST',
            headers: {
                correlationId: this.requestMaker.generateCorrelationId(),
                'Content-Type': 'application/json',
                'access-key': accessToken || '',
                'user-region': region || 'GB'
            },
            body: JSON.stringify(params)
        };
        const response = await this.requestMaker.fetch(this.functionURL.query, options);
        return response.body;
    }
    async prompt(prompts, skipModeration = false) {
        const url = `${this.url}/api/prompt`;
        const options = {
            method: 'POST',
            body: JSON.stringify({ prompts, skipModeration })
        };
        const expectedResponses = [200, 400];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        if (response.status === 400) {
            throw new errors_1.InappropriateContentError();
        }
        return response.json;
    }
    async generatePrompts(request) {
        const url = `${this.url}/api/generate-prompts`;
        const options = { method: 'POST', body: JSON.stringify(request) };
        const expectedResponses = [200];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        return response.json;
    }
    async search(request) {
        const url = `${this.url}/api/search`;
        const options = { method: 'POST', body: JSON.stringify(request) };
        const expectedResponses = [200];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        return response.json;
    }
    async explain(params, accessToken) {
        const options = {
            method: 'POST',
            headers: {
                correlationId: this.requestMaker.generateCorrelationId(),
                'Content-Type': 'application/json',
                'access-key': accessToken || ''
            },
            body: JSON.stringify(params)
        };
        const response = await this.requestMaker.fetch(this.functionURL.explain, options);
        return response.body;
    }
    async explainWrongAnswer(params, accessToken, region) {
        const options = {
            method: 'POST',
            headers: {
                correlationId: this.requestMaker.generateCorrelationId(),
                'Content-Type': 'application/json',
                'access-key': accessToken || '',
                'user-region': region || 'GB'
            },
            body: JSON.stringify(params)
        };
        const response = await this.requestMaker.fetch(this.functionURL.explainWrongAnswer, options);
        return response.body;
    }
    async examQuestionConversation(params, accessToken, region) {
        const options = {
            method: 'POST',
            headers: {
                correlationId: this.requestMaker.generateCorrelationId(),
                'Content-Type': 'application/json',
                'access-key': accessToken || '',
                'user-region': region || 'GB'
            },
            body: JSON.stringify(params)
        };
        const response = await this.requestMaker.fetch(this.functionURL.examQuestionConversation, options);
        return response.body;
    }
    async createUploadUrl(contentType) {
        const url = `${this.url}/api/files/upload-url`;
        const expectedResponses = [201, 422];
        const response = await this.requestMaker.makeRequest(url, {
            method: 'POST',
            body: JSON.stringify({ contentType })
        }, expectedResponses);
        if (response.status === 422) {
            const body = response.json;
            throw new FileUploadUnprocessableEntityError_1.FileUploadUnprocessableEntityError(body.reason);
        }
        return response.json;
    }
    async fetchSessions({ limit, lastKey } = {}) {
        const queryParams = this.encodeQueryParams({ limit, lastKey });
        const url = `${this.url}/api/sessions?${queryParams}`;
        const options = { method: 'GET' };
        const expectedResponses = [200, 400];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        if (response.status === 400) {
            throw new Error('Invalid request parameters');
        }
        return response.json;
    }
    async fetchSessionMessages(sessionId) {
        const url = `${this.url}/api/sessions/${sessionId}`;
        const options = { method: 'GET' };
        const expectedResponses = [200, 400];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        if (response.status === 400) {
            throw new Error('Invalid request parameters');
        }
        return response.json;
    }
    async renameSession({ sessionId, title }) {
        const url = `${this.url}/api/sessions/${sessionId}`;
        const options = {
            method: 'PATCH',
            body: JSON.stringify({ title })
        };
        const expectedResponses = [200, 400, 404];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        if (response.status === 400) {
            throw new Error('Invalid request parameters');
        }
        if (response.status === 404) {
            throw new Error('Session not found');
        }
        return response.json;
    }
    async deleteSession(sessionId) {
        const url = `${this.url}/api/sessions/${sessionId}`;
        const options = {
            method: 'DELETE'
        };
        const expectedResponses = [204, 400, 404];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        if (response.status === 400) {
            throw new Error('Invalid request parameters');
        }
        if (response.status === 404) {
            throw new Error('Session not found');
        }
        return response.json;
    }
    async generateImage({ prompt, orientation }) {
        const url = `${this.url}/api/generate-image`;
        const options = {
            method: 'POST',
            body: JSON.stringify({ prompt, orientation })
        };
        const expectedResponses = [200, 400, 401];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        if (response.status === 400) {
            throw new Error('Invalid request parameters');
        }
        if (response.status === 401) {
            throw new client_library_1.UnauthorizedError('Unauthorised user');
        }
        return response.json;
    }
    encodeQueryParams(params) {
        return Object.entries(params)
            .flatMap(([key, value]) => value ? `${encodeURIComponent(key)}=${encodeURIComponent(value)}` : [])
            .join('&');
    }
}
exports.default = ChatbotServiceClient;
//# sourceMappingURL=ChatbotServiceClient.js.map